/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerritoryItem
 */
export interface TerritoryItem {
    /**
     * Type of territory
     * @type {string}
     * @memberof TerritoryItem
     */
    type: TerritoryItemTypeEnum;
    /**
     * Name of the territory
     * @type {string}
     * @memberof TerritoryItem
     */
    name: string;
    /**
     * State where the territory is located
     * @type {string}
     * @memberof TerritoryItem
     */
    state: string;
    /**
     * City where the territory is located
     * @type {string}
     * @memberof TerritoryItem
     */
    city?: string;
}


/**
 * @export
 */
export const TerritoryItemTypeEnum = {
    Neighborhood: 'neighborhood',
    City: 'city',
    County: 'county',
    District: 'district',
    SubDistrict: 'sub-district',
    SchoolDistrict: 'school-district'
} as const;
export type TerritoryItemTypeEnum = typeof TerritoryItemTypeEnum[keyof typeof TerritoryItemTypeEnum];


/**
 * Check if a given object implements the TerritoryItem interface.
 */
export function instanceOfTerritoryItem(value: object): value is TerritoryItem {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function TerritoryItemFromJSON(json: any): TerritoryItem {
    return TerritoryItemFromJSONTyped(json, false);
}

export function TerritoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerritoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'state': json['state'],
        'city': json['city'] == null ? undefined : json['city'],
    };
}

export function TerritoryItemToJSON(json: any): TerritoryItem {
    return TerritoryItemToJSONTyped(json, false);
}

export function TerritoryItemToJSONTyped(value?: TerritoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'state': value['state'],
        'city': value['city'],
    };
}

